import React, { useCallback, useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import LockOutlined from '@mui/icons-material/LockOutlined';

import styles from './style';

interface LockedControlProps {
  children: React.ReactNode;
  // Shown on hover (ex: "Connecte-toi pour filtrer par jeu").
  tooltip: string;
  // A click opens the login popup (no hover on a phone).
  onClick: () => void;
  // Takes the whole width of its parent (a cell of the filter bar).
  fullWidth?: boolean;
}

// A control reserved to the connected users: it looks the same, a lock replaces its chevron,
// a tooltip on hover, the click asks to log in.
const LockedControl: React.FC<LockedControlProps> = React.memo((props) => {
  const {
    children,
    tooltip,
    onClick,
    fullWidth = false,
  } = props;

  const rootSx = useMemo(() => {
    if (fullWidth) {
      return { ...styles.root, ...styles.rootFull };
    }
    return styles.root;
  }, [fullWidth]);

  const onKeyDown = useCallback((event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  }, [onClick]);

  return (
    <Tooltip title={tooltip} placement="bottom" arrow>
      <Box role="button" tabIndex={0} aria-label={tooltip} onClick={onClick} onKeyDown={onKeyDown} sx={rootSx}>
        <Box className="locked-content" sx={styles.content} aria-hidden>
          {children}
        </Box>
        <LockOutlined className="locked-lock" sx={styles.lock} />
      </Box>
    </Tooltip>
  );
});

export default LockedControl;
